export default "__VITE_ASSET__D5cEZ8TK__"